import { Options } from 'vue-class-component';
import ThermoPreferenceComponent from '../ThermoPreferenceComponent';
import { TemperatureType } from '@/../client-generator/generated-clients/device-settings';

@Options({
  name: 'PreferenceCelsiusFahrenheit',
})
export default class PreferenceCelsiusFahrenheit extends ThermoPreferenceComponent {
  TemperatureType = TemperatureType;
}
